import { KeyboardBackspace } from '@material-ui/icons';
import get from 'lodash/get';
import groupBy from 'lodash/groupBy';
import keys from 'lodash/keys';
import { ReactElement, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

// Components.
import { ReportGroup } from './ReportGroup';

// Hooks.
import { useLoadEvent } from 'hooks';

// Store.
import { getReportsByWorkspaceId } from 'store/report/actions';
import { isLoadingReportsSelector, reportsSelector } from 'store/report/selectors';
import { ReportGroups } from 'store/report/types';
import { currentOrganizationContextSelector } from 'store/user/selectors';

// Styles.
import styles from './ReportPage.module.scss';

export const ReportPage = (): ReactElement => {
  const dispatch = useDispatch();
  const currentOrganization = useSelector(currentOrganizationContextSelector);
  const isLoadingReports = useSelector(isLoadingReportsSelector);
  const reports = useSelector(reportsSelector);
  const reportGroups = useMemo(() => groupBy(reports, (item) => get(item, 'group', 'Reports')), [reports]);

  const fireLoadEvent = useLoadEvent({ PageName: 'Report Dashboard', PageType: 'Report' });

  useEffect(() => {
    fireLoadEvent();
  }, [fireLoadEvent]);

  useEffect(() => {
    if (!reports && currentOrganization) {
      dispatch(getReportsByWorkspaceId(currentOrganization.organizationKind, currentOrganization.isJa));
    }
  }, [dispatch, reports, currentOrganization]);

  return (
    <div className={styles.container}>
      <div>
        <Link className={styles.link} to="/Dashboard">
          <KeyboardBackspace /> Dashboard
        </Link>
      </div>
      {reports?.length > 0 ? (
        keys(reportGroups).map((group, index) => (
          <ReportGroup group={group as ReportGroups} key={index} reports={reportGroups[group]} />
        ))
      ) : (
        <ReportGroup isLoading={isLoadingReports} />
      )}
    </div>
  );
};
